var Config = {
  /** URL */
  // ajaxUrl: "",
  ajaxUrl: "",//正式环境
};

window.Config = Config;
